import React from 'react';

const NotFound = () => {
    return (
        <div className="mt-5 pt-5 text-danger" style={{textAlign: "center"}}>
            <h1>404</h1>
            <h2>Page Not Found</h2>
        </div>
    );
};

export default NotFound;